import { CommonModule } from '@angular/common';
import { 
  Component, 
  Input, 
  Output, 
  EventEmitter, 
  signal, 
  WritableSignal,
  HostListener,
  ElementRef,
  inject,
  OnInit
} from '@angular/core';

@Component({
  selector: 'app-minimal-select',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './minimal-select.component.html',
  styleUrls: ['./minimal-select.component.scss']
})
export class MinimalSelectComponent implements OnInit {
  @Input() options: number[] = [];
  @Input() placeholder: string = 'Seleccionar';
  @Input() initialValue: number | null = null;
  
  @Output() selectionChange = new EventEmitter<number>();

  private elementRef = inject(ElementRef);
  
  isOpen: WritableSignal<boolean> = signal(false);
  selectedValue: WritableSignal<number | null> = signal(null);

  ngOnInit(): void {
    if (this.initialValue !== null) {
      this.selectedValue.set(this.initialValue);
    }
  }

  toggle(): void {
    this.isOpen.set(!this.isOpen());
  }

  selectOption(option: number): void {
    this.selectedValue.set(option);
    this.isOpen.set(false);
    this.selectionChange.emit(option);
  }

  getDisplayValue(): string {
    const selectedValue = this.selectedValue();
    return selectedValue !== null ? selectedValue.toString() : this.placeholder;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.isOpen.set(false);
    }
  }
}